import { getAuthData } from '../authDataService';
import { getCodeFromUrlParams } from './searchParamsUtils';
import type { AuthConfig } from '../types';

const getCodeVerifier = (): string => {
    const verifier = getAuthData().codeVerifier;

    if (verifier) {
        return verifier;
    }

    return '';
};

export const getTokenBodyFromConfig = (environment: AuthConfig, code?: string): URLSearchParams => {
    const body = new URLSearchParams();

    body.append('grant_type', 'authorization_code');
    body.append('client_id', environment.clientId);
    body.append('redirect_uri', environment.auth.redirectUri);

    body.append('code', code || getCodeFromUrlParams());
    body.append('code_verifier', getCodeVerifier());
    if (environment.auth.clientSecret) {
        body.append('client_secret', environment.auth.clientSecret);
    }

    return body;
};
